import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { PatientLookup } from "@/components";
import styles from "./MedicalMemberLookupPage.module.scss";


export const MedicalMemberLookupPage: FC = () => {


  return (
    <div className={styles.MedicalPanelContainer}>
      <Stack spacing="large">
        <PatientLookup />
      </Stack>
    </div>
  );
};

export default MedicalMemberLookupPage;
